// SSR-safe wrapper. Quill (and react-quilljs) reach for `document` at module
// load time, which crashes Next's server bundle when EditorInput appears in
// any SSR'd dependency graph (e.g. via LayoutWrapper → SectionLayout). Loading
// the real implementation client-only via next/dynamic keeps Quill out of the
// server bundle entirely.
import dynamic from 'next/dynamic';

const EditorInput = dynamic(() => import('./EditorInput.client'), {
  ssr: false,
});

export default EditorInput;
